export default from './Block';



// WEBPACK FOOTER //
// ./src/components/atoms/Block/index.js